import { defineStudy } from './registry';
import { mpoxVaccineScreeningQuestions } from '../../../data/pre-screener-config/MpoxVaccineScreener';
import { mpoxEligibleZipCodes } from '../../../data/vaccine-study-zipcodes';

const COMMON_QUESTION_IDS = ["age_eligibility", "past_vaccine_study_participation"];

/**
 * Mpox Vaccine Study
 * VMPOX046
 * Priority: 8 (tentative)
 * Target: Healthy adults aged 18-49
 * Zipcodes: TEMPORARY PLACEHOLDER - needs official list
 */
export const mpoxVaccineStudy = defineStudy({
  id: "mpox-vaccine",
  name: "Mpox Vaccine Study for Healthy Adults",
  trialId: "VMPOX046",
  priority: 8,
  eligibleZipCodes: Array.from(mpoxEligibleZipCodes),
  questions: mpoxVaccineScreeningQuestions,
  commonQuestionIds: COMMON_QUESTION_IDS,
  // Required common answer values (age 18-49)
  commonAnswerRequirements: {
    age_eligibility: ["18_to_49"],
  },
});
